import React from 'react';
import { smsHref, whatsappHref } from '../wallets';

function OutreachButtons({ phone, text, className }) {
    if (!phone || !text) return null;
    return (
        <div className={'d-flex gap-2 flex-wrap ' + (className || '')}>
            <a className="btn btn-success btn-sm" href={whatsappHref(phone, text)} target="_blank" rel="noreferrer">WhatsApp</a>
            <a className="btn btn-outline-secondary btn-sm" href={smsHref(phone, text)}>SMS</a>
        </div>
    );
}

export default OutreachButtons;
